import { type SVGProps, useId } from "react";

export function CommissionsIcon(props: SVGProps<SVGSVGElement>) {
	const titleId = useId();
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			strokeWidth={1.5}
			role="img"
			aria-labelledby={titleId}
			{...props}
		>
			<title id={titleId}>Commissions</title>
			<path
				d="M7.99992 8.00016H8.00659M10.6666 4.00016V2.66683C10.6666 2.31321 10.5261 1.97407 10.2761 1.72402C10.026 1.47397 9.68687 1.3335 9.33325 1.3335H6.66658C6.31296 1.3335 5.97382 1.47397 5.72378 1.72402C5.47373 1.97407 5.33325 2.31321 5.33325 2.66683V4.00016M14.6666 8.66683C12.6884 9.97282 10.3703 10.669 7.99992 10.669C5.62955 10.669 3.31139 9.97282 1.33325 8.66683M2.66659 4.00016H13.3333C14.0696 4.00016 14.6666 4.59712 14.6666 5.3335V12.0002C14.6666 12.7365 14.0696 13.3335 13.3333 13.3335H2.66659C1.93021 13.3335 1.33325 12.7365 1.33325 12.0002V5.3335C1.33325 4.59712 1.93021 4.00016 2.66659 4.00016Z"
				stroke="currentColor"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
